import api from '@/services/api'
import type { SplashesFilter, SplashesResponse, SplashesSortingKey } from './types'
import type { SortOrder } from '../alerts-v2-service/types'

export const SplashesV2Service = {
  fetchSplashes(
    page: number,
    filters: SplashesFilter,
    sortField: SplashesSortingKey,
    sortOrder: SortOrder,
  ) {
    return api.post<SplashesResponse>(
      `/v2/splashes?page=${page}&sort_field=${sortField}&sort_order=${sortOrder}`,
      filters,
    )
  },
}
